import { supabase } from './supabase';
import { logOutRevenueCat } from './purchases';
import { trackAuthSignedOut } from './product-events';
import { markAuthEntrySeen } from './auth-device-state';

/**
 * Run the full sign-out cleanup: emit the sign-out event, unregister the push
 * token, log out of RevenueCat, and clear the Supabase session. Callers are
 * responsible for navigating to the login screen afterwards.
 *
 * `unregisterPushNotifications` is taken as a parameter because the
 * underlying tRPC mutation only works from within a React component tree
 * (via useUnregisterPushNotifications).
 */
export async function performSignOut(options: {
  source: string;
  route?: string;
  unregisterPushNotifications: () => Promise<void>;
}): Promise<void> {
  const { source, route, unregisterPushNotifications } = options;
  trackAuthSignedOut({
    source,
    route: route ?? null,
  });
  await markAuthEntrySeen();
  await unregisterPushNotifications();
  await logOutRevenueCat();
  await supabase.auth.signOut();
}
